import invariant from 'invariant';

const PRIORITY_WEIGHTS = {
  problem: 4,
  disconnected: 3,
  warning: 2,
  ok: 1,
};

export default function getPriorityForStatus(status) {
  const weight = PRIORITY_WEIGHTS[status];
  invariant(weight !== undefined, `No sort weight for status: ${status}`);
  return weight;
}



// WEBPACK FOOTER //
// ./src/helpers/getPriorityForStatus.js